import '@vfde-brix/accordion/dist/styles.css';

import { createAccordionComponent } from '@vfde-brix/accordion';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-accordion');

for (let i = 0, x = elements.length; i < x; i += 1) {

    const containerElement = elements[i].parentElement;

    createAccordionComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
